<!-- Universal Menu Component -->

<template>
	<div class="menu_main" v-bind:style="{ 'background-color': menu.bg_color}">
		<div v-if="show_title=='1'" class="title">{{menu.title}}</div>
		
		<span v-for="(link, idx) in menu.locs" :key="idx">

			<!-- First Icon spacer -->
			<div class="h-spacer" :style="'width:' + icoSpace + 'px'" v-if="menu_type=='ico' && idx==0" ></div>

			<!-- Icon Link -->
			<router-link v-if="menu_type=='ico'" :to="link.path" :title="link.tooltip"> 
				<UniIcon 
					:ico="link.ico" 
					v-bind="link.params" 
					:color="link.color"
					:w="icoSize"
					:h="icoSize"
					:pad="icoPad"
				/>
			</router-link>

			<!-- In-between Icon spacer -->
			<div class="h-spacer" :style="'width:' + icoSpace + 'px'" v-if="menu_type=='ico' && idx<menu.locs.length" ></div>

			<!-- Text Link -->
			<span v-if="menu_type!='ico' && idx>0" >
				|
			</span>
			<router-link v-if="menu_type!='ico'" :to="link.path" :title="link.tooltip">
				{{link.title}}
			</router-link>

		</span>

	</div>

</template>

<script>
import { m } from "@/utils/utils";
import Vue from 'vue';
import {CfgMnu} from '@/assets/cfg/CfgMnu';

export default {
	props: {
		menu_id:	{default: 'user'},
		menu_type:	{default: 'txt'},
		show_title: {default: '1'},
		icoSize: {type: Number, default: 30},
		icoPad: {type: Number, default: 2},
		icoSpace: {type: Number, default: 5},
	},
	data() {
		return {
			CfgMnu: CfgMnu,
			menu: {},
			params:{w:32, h:32},
			std_color:"#AAA",
			hot_color: "#090",
		}
	},
	watch: {
		'$route' (to, from) {
			this.setMenuColorByPath(to.path);
		},
		'menu_id' (to, from) {
			this.validate();
		}
	},
	methods: {
		validate() {
			if (!this.CfgMnu[this.menu_id]) {
				m("invalid menu id: " + this.menu_id);
				this.menu_id = "user";
			}
			this.menu = this.CfgMnu[this.menu_id];

			for(var item of this.menu.locs) {
				item.params = this.params;
				item.color = this.std_color;
				this.setMenuColorByPath(this.$route.path);
			}
		},
		setMenuColorByPath(path) {
			for(var i in this.menu.locs) {
				let item = this.menu.locs[i];
				item.color = (item.path === path)? this.menu.hot_color: this.menu.std_color;
				Vue.set(this.menu.locs, i, item);
			}
		},
	},
	created() {
		this.validate();
	},
}
</script>

<style scoped>
.menu_main {
	/* background-color: #F9FFF9; */
	display: inline-block;
	/* float:left; */
	/* width: 400px; */
	vertical-align: top;
	/* padding: 5px; */
	white-space: nowrap;
	overflow: hidden;
	border: solid 0px #CCC;
}
.title {
	height: 20px;
	width: 120px;
	overflow: hidden;
	border: solid 0px #C30;
}

.h-spacer {
	display: inline-block;
	height: 10px;
	width: 10px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #C30;
}

a {
	color: #666;
	text-decoration: none;
}

a.router-link-exact-active {
	color: #0C0;
}

</style>
